import { MAX_VISIBLE } from './config'
import type * as models from './models'

/**
 * {@link https://ngrx.io/docs State} of this feature
 */
export interface State {
  toasts: readonly models.Toast[]
}
export namespace State {
  export const INITIAL: State = {
    toasts: [],
  }

  export function add(state: State, ...toasts: readonly models.Toast[]): State {
    if (toasts.length === 0) {
      return state
    }

    return {
      ...state,
      toasts: [...toasts, ...state.toasts].slice(0, MAX_VISIBLE),
    }
  }

  export function dismiss(state: State, id: models.Toast.Id): State {
    return {
      ...state,
      toasts: state.toasts.filter(toast => toast.id !== id),
    }
  }

  export function dismissAll(state: State): State {
    return {
      ...state,
      toasts: [],
    }
  }
}
